import { BodyBasedExpression } from './Expression.js';
export class OclIsKindOfExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        const body = this.getBody() ? this.getBody().evaluate(visitor, localVariables) : undefined;
        if (!body) {
            return false;
        }
        return source instanceof body;
    }
}
//# sourceMappingURL=OclIsKindOfExpression.js.map